import { render } from "./VensysHistoricProductionComponent.vue?vue&type=template&id=311ea1a1&scoped=true&ts=true"
import script from "./VensysHistoricProductionComponent.vue?vue&type=script&lang=ts"
export * from "./VensysHistoricProductionComponent.vue?vue&type=script&lang=ts"

import "./VensysHistoricProductionComponent.vue?vue&type=style&index=0&id=311ea1a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311ea1a1"]])

export default __exports__